const expenseItemFields = [
  'infoMedicalExpensesItems',
  'infoOpticalTreatmentItems',
  'infoAncillaryServicesItems',
  'infoMentalHealthItems',
  'infoSexualHealthItems',
  'infoExtraTravelAndAccommodationItems',
  'infoSearchAndRescueItems',
  'infoUrgentCareOutOfHoursVisitsItems',
  'infoPrescriptionsItems',
  'infoGPVisitsItems',
  'infoRehabilitationAndOccupationalTherapyItems',
  'infoMaternityCareItems',
  'infoReplacementStaffItems',
  'infoRepatriationBenefitItems',
  'infoOtherMedicalExpensesItems',
  'infoMedicalExpensesHospitalisedItems',
  'infoMedicalExpensesCompanionItems',
  'infoDentalExpensesItems',
  'infoFuneralExpensesItems',
  'infoTheDeathCausedByAnInjuryItems',
  'infoExpensesArisingFromTerrorismItems',
];

export const hasAnyMedicalAndEvacuationExpenseItems = (form = {}) =>
  expenseItemFields.some((field) => {
    const arr = form[field] && typeof form[field].toJS === 'function' ? form[field].toJS() : form[field];
    return Array.isArray(arr) && arr.length > 0;
  });



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.MedicalAndEvacuation/validation.js